import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { Icons } from '@/icons/icons'
import { CounterInfo } from '@/components/counters/types/CounterTypes'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfWhiteCounterComponent',
  props: {
  info: {
    type: Object as PropType<CounterInfo>,
    required: true
  },
  showSpinner: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const props = __props;



const tooltipIcon = Icons.INFO_FULL

const formattedNumber = computed(() => {
  return props.info.qty.toString().length > 1 ? props.info.qty : ('00' + props.info.qty).slice(-2)
})

// METHODS
function executeAction() {
  if (props.info.action) props.info.action()
}

return { __sfc: true,props, tooltipIcon, formattedNumber, executeAction, SpinnerLayerComponent, LexonTooltipComponent }
}

})